import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericGridComponent } from '../../../common/components/generic-grid/generic-grid.component';
import { LoadingService } from '../../../common/components/loading/loading.service';
import { AlertifyService } from '../../../common/services/alertify.service';
import { UnitVM } from '../../../models/view-models';
import { UnitsService } from '../../../services/units.service';

@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.scss']
})
export class UnitsComponent implements OnInit {

  units: UnitVM[] = [];
  unit: UnitVM;
  entityForm: FormGroup;
  showForm: boolean = false;
  isEdition: boolean = false;

  @ViewChild("grid", { read: GenericGridComponent, static: false })
  public grid: GenericGridComponent;
  @ViewChild("code") code: ElementRef;
  @ViewChild("name") name: ElementRef;

  constructor(private unitsService: UnitsService,
    private fb: FormBuilder,
    private alertify: AlertifyService,
    private loading: LoadingService) { }

  ngOnInit(): void {
    this.initForm();
    this.loadData();
  }

  initForm() {
    this.entityForm = this.fb.group({
      Code: ['', [Validators.required, Validators.minLength(2)]],
      Name: ['', [Validators.required, Validators.minLength(2)]],
    });
  }

  loadData() {
    this.loading.show();
    this.unitsService.getAll()
      .subscribe((response: UnitVM[]) => {
        if (response) {
          this.units = response;
        }
        this.setGridOptions();
        this.loading.hide();
      }, (err) => {
        this.loading.hide();
      });
  }

  setGridOptions() {
    this.grid.setData(this.units);
    this.grid.options.toolbarTitle = "Unidades";
    this.grid.options.showDetailsButton = false;
    this.grid.columns = [
      { field: "Code", title: "Código" },
      { field: "Name", title: "Nombre" },
      //{ field: "Description", title: "Descripción" },
    ];
    this.grid.setGridOptions();
  }

  setFormVisibility = () => this.showForm = !this.showForm;

  addNew() {
    this.isEdition = false;
    this.setFormVisibility();
    setTimeout(() => {
      this.code.nativeElement.focus();
      //this.code.nativeElement.value = "";
    }, 0);
  }

  isValidForm(): boolean {
    return this.entityForm.valid;
  }

  save() {
    if (this.isValidForm()) {
      this.loading.show();
      const entity: UnitVM = Object.assign(this.entityForm.value);
      this.unitsService.insert(entity)
        .subscribe((response: UnitVM) => {
          if (response) {
            this.grid.addRow(response);
            this.cancel();
            this.loading.hide();
          }
        }, (err) => {
          this.loading.hide();
        });
    }
  }

  cancel() {
    this.initForm();
    this.setFormVisibility();
  }

  edit(value: UnitVM) {
    this.unit = value;
    this.entityForm.setValue({
      Code: this.unit.Code,
      Name: this.unit.Name,
    });
    this.isEdition = true;
    this.setFormVisibility();
    setTimeout(() => {
      this.name.nativeElement.focus();
    }, 0);
  }

  update() {
    if (this.isValidForm()) {
      this.loading.show();
      const entity: UnitVM = Object.assign({
        UUID: this.unit.UUID
      }, this.entityForm.value);
      this.unitsService.update(entity)
        .subscribe((response: UnitVM) => {
          if (response) {
            this.grid.updateRowByUUID(response);
            this.cancel();
            this.loading.hide();
          }
        }, (err) => {
          this.loading.hide();
        });
    }
  }

  delete(value: UnitVM) {
    this.alertify.confirm(
      `Eliminar unidad de medida ${value.Name}`,
      () => {
        this.unitsService.delete(value.UUID)
          .subscribe((response: boolean) => {
            if (response) {
              this.grid.deleteRow(value.UUID);
              this.loading.hide();
            }
          }, (err) => {
            this.loading.hide();
          });
      });
  }

}
